import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Chip } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
export const ProfileBetaTesterChipFragment = graphql(`
  fragment ProfileBetaTesterChip on Profile {
    isBetaTester
  }
`);
export function ProfileBetaTesterChip(t0) {
  const $ = _c(9);
  const {
    profile: profileKey,
    variant: t1,
    chipVariant
  } = t0;
  const variant = t1 === undefined ? "full" : t1;
  const profile = readFragment(ProfileBetaTesterChipFragment, profileKey);
  const t = useTranslations("ProfileBetaTesterChip");
  if (!profile.isBetaTester) {
    return;
  }
  const t2 = variant === "compact" ? "closedBetaTesterCompact" : "closedBetaTester";
  let t3;
  if ($[0] !== t || $[1] !== t2) {
    t3 = t(t2);
    $[0] = t;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <span className="text-blue-3 dark:text-blue-1/80">{t3}</span>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute inset-0 bg-gradient-to-br from-blue-1/25 to-blue-1/15" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== chipVariant || $[7] !== t4) {
    t6 = <Chip className="relative overflow-hidden border-blue-3/40 dark:border-blue-1/40" variant={chipVariant}>{t4}{t5}</Chip>;
    $[6] = chipVariant;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}